import React, { useContext } from "react";

import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import clsx from "clsx";
import { useParams } from "react-router-dom";
import mainStyles from "styles";

import { OrgDetailsContext } from "../../../../context/organisation-context";
import { SnackbarContext } from "../../../../context/snackbar-context";
import { UrlParamTypes } from "../../../../types/org-display";
import { TrainingMigrationProvider } from "./context/training-migration-provider";
import { TrainingDataMigration } from "./training-data-migration";
import { TrainingTranslationUpgradeSpreadsheetDownload } from "./training-translation-upgrade-spreadsheet-download";
import { TriggerTranslationUpgrade } from "./trigger-translation-upgrade";

export const TrainingDataMigrationWrapper: React.FC = () => {
  const { roleId, regionCode } = useParams<UrlParamTypes>() || {};
  const { showError } = useContext(SnackbarContext);
  const { orgDetails } = useContext(OrgDetailsContext);
  const classes = mainStyles();

  return (
    <TrainingMigrationProvider
      roleId={roleId}
      regionCode={regionCode}
      showError={showError}
      orgDetails={orgDetails}
    >
      <Table>
        <TableBody>
          <TrainingDataMigration regionCode={regionCode} />
          <TableRow>
            <TableCell
              colSpan={3}
              className={clsx(classes.tableCell)}
              style={{ paddingTop: "24px", paddingBottom: "16px" }}
            >
              <Typography
                variant="h6"
                style={{ fontWeight: 600, marginBottom: "8px" }}
              >
                Translations
              </Typography>
              <Divider />
            </TableCell>
          </TableRow>
          <TrainingTranslationUpgradeSpreadsheetDownload />
          <TriggerTranslationUpgrade />
        </TableBody>
      </Table>
    </TrainingMigrationProvider>
  );
};
